import { Window } from '../contexts/index.jsx'

const LinkHelper = {
    listingLink: (listing) => {
        return LinkHelper.link('/product/' + listing.id)
    },

    link: (path) => {
        const { protocol, host } = Window.location

        return protocol + '//' + host + path
    },

    referralLink: (code) => {
        return LinkHelper.link('/?ref=' + code)
    }
}

export default LinkHelper
